import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from "@angular/core";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { PATTERN_ALPHA_NUMERIC_WITH_SPC_CHAR, PATTERN_EMAIL } from "src/app/utils/constant";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { WebUserService } from "../web-user.service";
import { finalize, map, takeUntil, tap, catchError } from "rxjs/operators";
import { fromEvent, of as observableOf } from "rxjs";
import * as _ from "lodash";

import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipList } from '@angular/material/chips';

@Component({
  selector: 'esc-web-user-form',
  templateUrl: './web-user-form.component.html',
  styleUrls: ['./web-user-form.component.scss']
})
export class WebUserFormComponent implements OnInit, OnDestroy {
  @Input() detail;
  @Input() mode;
  @Output() saving = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  @ViewChild('chipsCompany') chipsCompany: MatChipList;
  @ViewChild('companyAC') companyACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) companyACTr: MatAutocompleteTrigger;

  public companySelectorLabel = "LABEL_COMPANY";
  
  public isDisabled;
  loading = {
    submit: false,
    company: false,
    init: false,
  };
  roleRequired;
  companyRequired;

  public defaultOption = {
    id: 0,
    code: 'all',
    description: 'All'
  };

  public filters;

  filterOptions = {
    company: []
  };

  multiSelect = {
    selectedCompanies: [this.defaultOption],
  };

  public isGlobalSchema = this.helper.isGlobalSchema();
  private hasLoadedPreviousCompanies = false;

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    private userMntService: WebUserService,
    public languageService: LanguageService,
    ) { }

  public formGroup: FormGroup;

  ngOnInit() {
    this.loading.init = true;
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
    this.getInitialData('company');
  }

  ngOnDestroy() {

  }

  initForm() {
    // REWARDS-1341
    // If not in global schema, we will set value for status checkbox to web_user_role.is_active
    const isActiveColumn = this.helper.isGlobalSchema() ? "is_active" : "web_user_role_is_active";

    this.formGroup = this.fb.group({
      username: [_.get(this.detail, "username"), [Validators.required, Validators.maxLength(16), Validators.minLength(8), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPC_CHAR)]],

      fullname: [_.get(this.detail, "fullname"), [Validators.required, Validators.maxLength(250)]],

      email_address: [_.get(this.detail, "email_address"), [Validators.required, Validators.pattern(PATTERN_EMAIL)]],

      role: [_.get(this.detail, "role"), [Validators.required]],

      company: [_.get(this.detail, "company"), [Validators.required]],

      status: _.get(this.detail, isActiveColumn) == 1 ? true : false
    });

    this.toggleDisable();
  }

  toggleDisable() {
    if (!_.get(this.detail, 'id')) {
      this.formGroup.get("status").setValue(true);
      this.formGroup.get("status").disable({ emitEvent: false });
    } else {
      this.formGroup.get('email_address').disable({ emitEvent: false});
      this.formGroup.get("username").disable({ emitEvent: false });
    }
  }

  roleSelected(ev) {
    this.formGroup.get('role').setValue(ev);
    this.formGroup.get('role').markAsTouched();
  }

  companySelected(ev) {
    this.formGroup.get('company').setValue(ev);
    this.formGroup.get('company').markAsTouched();
  }

  isFormValid() {
    if(this.formGroup.valid) {
      this.saveChanges()
    }
    else {
      for (let ctrl in this.formGroup.controls) {
        if(!this.formGroup.controls[ctrl].valid) {
          this[ctrl+"Required"] = true;
        }
      }
    }
  }

  saveChanges() {
    this.loading.submit = true;
    this.formGroup.disable();
    this.isDisabled = true;

    // Get value of status in form group
    const formGroupIsActive = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    // Get initial is_active value, set to 1 for new user
    let is_active = _.get(this.detail, "id") ? _.get(this.detail, "is_active") : 1;

    // Get initial web_user_role_is_active value
    let web_user_role_is_active = _.get(this.detail, "web_user_role_is_active") ? 1 : 0;

    // If in global schema we will update web_user.is_active, else we will update web_user_role.is_active
    if (this.helper.isGlobalSchema()) {
      is_active = formGroupIsActive;
    } else {
      web_user_role_is_active = formGroupIsActive;
    }

    let obj = {
      data: [
        {
          id: _.get(this.detail, "id") || 0,

          username: _.toUpper(_.get(this.formGroup.get("username"), "value")),

          fullname: _.toUpper(_.get(this.formGroup.get("fullname"), "value")),

          email_address: _.get(this.formGroup.get("email_address"), "value"),

          role_code: _.get(this.formGroup.get("role"), "value.code"),

          // company_id: _.toInteger(_.get(this.detail, "company_id")) || _.toInteger(_.get(this.detail, "company.id")) || 1,

          company_id: _.map(this.multiSelect.selectedCompanies, val => val.id),

          is_active: is_active,

          web_user_role_is_active: web_user_role_is_active
        }
      ]
    };

    console.log("OBJ: " + JSON.stringify(obj))

    this.saving.emit(true);

    this.userMntService.insert(obj).pipe(
      finalize(() => {
        this.loading.submit = false;
        this.saving.emit(false);
        this.formGroup.enable();
        this.toggleDisable();
        this.isDisabled = false;
      }))
      .subscribe(
        (res: any) => {
          this.loading.submit = false;
          if (environment.showLogs) {
            console.log(res);
          }

          if ((_.has(res, 'status') && _.get(res, 'status') == 0) || _.get(res, 'error.count') > 0) {
            this.helper.networkErrorMessage();
            return;
          }

          if(this.helper.displayErrorMessage(res)) return;

          if (_.get(res, 'success.count') > 0) {
            //the ff needs to be an obj to display detail correctly
            obj.data[0]["role"] = _.get(this.formGroup.get("role"), "value");
            obj.data[0]["company"] = _.get(this.formGroup.get("company"), "value");
            obj.data[0]["web_user_company_list"] = this.multiSelect.selectedCompanies; // Adding this since not returned in insert api response

            this.saving.emit(obj.data);
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
            this.close(true);
          }
        },
        err => {
          console.log(err);
        }
      );
  }

  disableSaveBtn() {
    return this.loading.submit || (this.formGroup.touched && !this.formGroup.valid)
  }

  confirmChanges() {
    if(this.formGroup.touched && this.formGroup.valid) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_SAVE_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if(result) {
          this.saveChanges();
        } else {
          this.close(false);
        }
      })
    }
    else {
      this.close(false);
    }
  }

  close(data) {
    this.closeForm.next(data);
  }

  toggleSelection(data, srcArray, targetArray, formControlName, inputElem) {
    if (inputElem) {
      inputElem.value = '';
    }
    data.selected = !data.selected;

    //if 'all' is selected, choose only all
    if (data.selected == true && data.code == 'all') {
      srcArray.forEach((e) => {
        e.selected = true;
      });
      this.multiSelect[targetArray] = [];
      this.multiSelect[targetArray].push(data);
      this.disableCheckbox(srcArray, formControlName, data);
    }

    //if 'all' is deselected, unselect everything
    else if (data.selected == false && data.code == 'all') {
      srcArray.forEach((e) => {
        e.selected = false;
      });
      this.multiSelect[targetArray].splice(
        this.multiSelect[targetArray].indexOf(data),
        1
      );
      this.enableCheckbox(srcArray);
    } else if (this.multiSelect[targetArray].indexOf(data) == -1) {
      //if other option is selected, check if 'all' is already selected and clear selection
      // this.multiSelect[targetArray].some(opt => opt.code == data.code)
      if (this.multiSelect[targetArray].indexOf(this.defaultOption) > -1) {
        srcArray.forEach((e) => {
          e.selected = false;
        });
        this.multiSelect[targetArray] = [];
      }
      //if data exists in array, remove from list
      else if (
        this.multiSelect[targetArray].some((opt) => opt.code == data.code)
      ) {
        let index = _.findIndex(this.multiSelect[targetArray], function (item) {
          return item['code'] == data.code;
        });
        this.multiSelect[targetArray].splice(index, 1);
      } else {
        this.multiSelect[targetArray].push(data);
      }
    } else {
      this.multiSelect[targetArray].splice(
        this.multiSelect[targetArray].indexOf(data),
        1
      );
      srcArray.forEach((e) => {
        if (e.id == data.id) {
          e.selected = false;
        }
      });
    }


    this.assignFormValues(targetArray, formControlName);
  }

  enableCheckbox(optionArray) {
    optionArray.forEach((e) => {
      e.disabled = false;
    });
  }

  disableCheckbox(optionArray, formControlName, data) {
    if (
      (optionArray[0].selected &&
        _.has(this.formGroup.get(formControlName), 'value') &&
        this.formGroup.get(formControlName).value == 0) ||
      _.get(data, 'code') == 'all'
    ) {
      optionArray.forEach((e) => {
        if (e.code != 'all') {
          e.disabled = true;
        }
      });
    } else {
      this.enableCheckbox(optionArray);
    }
  }

  assignFormValues(targetArray, formControlName) {
    let tempArr = this.multiSelect[targetArray].map(e => {
      let obj = {
        code: e.code,
        description: e.description
      }
      return obj;
    });
    
    let val = _.cloneDeep(tempArr);
    this.formGroup.controls[formControlName].patchValue(val);
  }

  getInitialData(name) {
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.filterOptions[name] = [];
    
    // For non-global schema, we do not fetch company list and just assign the current company to the user
    if (name === 'company' && !this.isGlobalSchema) {
      const company = JSON.parse(localStorage.getItem("company"));
      if (company) {
        this.filterOptions.company = [company];
        this.multiSelect.selectedCompanies = [company];
        this.assignFormValues('selectedCompanies', 'company');
      }
      this.loading.init = false;
    } else {
      this.getData(name);
    }
  }

  getData(name) {
    let filters = _.cloneDeep(this.filters);
    this.filters.getMore = false;
    this.loading[name] = true;
    switch (name) {
      case 'company': {
        this.userMntService
          .getCompanyList(filters)
          .pipe(
            tap(() => (this.loading.company = true)),
            finalize(() => {
              this.loading.company = false;
              return observableOf(null);
            }),
            catchError((err) => {
              console.error(err);
              this.loading.company = false;
              return observableOf(null);
            })
          )
          .subscribe((res: any) => {
            if (filters.web_filter.offset === 0) {
              this.filterOptions[name][0] = this.defaultOption;
            }
            this.handleFilterResponse(res, 'company', filters, 'selectedCompanies');
          });
        break;
      }
    }
  }

  handleFilterResponse(res, filterName, filters, selectedArrayGroup = null) {
    this.loading[filterName] = false;
    if (environment.showLogs) {
      console.log(res);
    }
    if (
      res == null ||
      res.status == 0 ||
      res.status == 504 ||
      res.status == 500
    ) {
      this.dialogService.openSnackBar(this.languageService.getTranslation('MSG_ERROR_NETWORK_CONNECTION', {}));
      this.loading.init = false;
      return;
    }
    if (_.has(res, 'value') && res.value == 'Success') {
      this.filterOptions[filterName] = this.filterOptions[filterName].concat(
        res.data
      );
      if (selectedArrayGroup) {
        this.checkSelected(filterName, selectedArrayGroup, filterName);
      }

      // Load previous selected companies only once
      if (filterName === 'company' && !this.hasLoadedPreviousCompanies) {
        this.hasLoadedPreviousCompanies = true;
        this.loadPreviousSelectedCompanies();
      }

      if (
        res.data.length > 0 &&
        this.filterOptions[filterName].length < _.get(res, 'count')
      ) {
        this.filters.getMore = true;
      }

      // Turn off init loading after first load
      if (filters.web_filter.offset === 0) {
        this.loading.init = false;
      }
    }
  }

  checkSelected(srcArray, targetArray, formControlName) {
    if (this.multiSelect[targetArray].some((opt) => opt.description == 'All')) {
      let tempObj = _.cloneDeep(this.defaultOption);
      tempObj['selected'] = false;
      this.toggleSelection(
        tempObj,
        this.filterOptions[srcArray],
        targetArray,
        formControlName,
        null
      );
    } else if (this.multiSelect[targetArray].length) {
      this.filterOptions[srcArray].forEach((e) => {
        this.multiSelect[targetArray].forEach((v) => {
          if (e.description == v.description) {
            e.selected = v.selected;
          }
        });
        if (e.description == 'All') {
          e.selected = false;
        }
      });
    }
  }

  loadPreviousSelectedCompanies() {
    const companies = _.get(this.detail, 'web_user_company_list');
    if (companies && companies.length > 0) {
      const companyIds = companies.map(c => c.id);

      // Initialize multi selected companies
      this.multiSelect.selectedCompanies = [];
      
      // Check if ALL is selected
      if (companyIds.includes(0)) {
        // Use toggleSelection to select ALL
        let allOption = this.filterOptions.company.find(c => c.code === 'all') || this.defaultOption;
        allOption.selected = false; // Set to false so toggleSelection will make it true
        this.toggleSelection(allOption, this.filterOptions.company, 'selectedCompanies', 'company', null);
      } else {
        // Select specific companies directly without using toggleSelection
        const selectedCompanies = [];
        this.filterOptions.company.forEach(c => {
          if (companyIds.includes(c.id)) {
            c.selected = true;
            selectedCompanies.push(c);
          }
        });
        
        // Set selected companies directly
        this.multiSelect.selectedCompanies = selectedCompanies;
        this.assignFormValues('selectedCompanies', 'company');
      }
    }
  }

  getMoreData(name) {
    if (this.filters.getMore) {
      this.filters.web_filter.offset += INITIAL_OPTIONS.web_filter.limit;
      this.getData(name);
    }
  }

  optionClicked(event: Event, data, srcArray, targetArray, formControlName, inputElem) {
    event.stopPropagation();
    this.toggleSelection(data, srcArray, targetArray, formControlName, inputElem);
  }

  checkAutocompleteObject(control, objectKey, targetArray) {
    if ((!_.isObject(control.controls[objectKey].value) || control.controls[objectKey].value.id == null) && (control.controls[objectKey].value != null && control.controls[objectKey].value != "")) {
      control.controls[objectKey].setErrors({
        notExisting: true
      });
    }

    if (_.size(this.multiSelect[targetArray]) && targetArray) {
      control.controls[objectKey].setValue(null);
      this.assignFormValues(targetArray, objectKey);
    }
  }

  displayFn(data?: any): string | undefined {
    return data ? _.get(data, 'code') + ' - ' + _.get(data, 'description') : null;
  }

  autocompleteScroll(name, refName, acTrigger) {
    setTimeout(() => {
      if (this[refName].isOpen || this[refName].panel) {
        fromEvent(this[refName].panel.nativeElement, 'scroll')
          .pipe(
            map((x) => this[refName].panel.nativeElement.scrollTop),
            takeUntil(this[acTrigger].panelClosingActions)
          )
          .subscribe((x) => {
            const scrollTop = this[refName].panel.nativeElement.scrollTop;
            const scrollHeight = this[refName].panel.nativeElement.scrollHeight;
            const elementHeight =
              this[refName].panel.nativeElement.clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            if (atBottom) {
              this.getMoreData(name);
            }
          });
      }
    });
  }

}

const INITIAL_OPTIONS = {
  module_code: 'PAR',
  web_filter: {
    limit: 50,
    offset: 0,
    keyword: '',
    industry_type_ids: 0,
    status: 1,
    filters: {}
  },
  getMore: false
};